import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ProjectResourcesService } from 'src/app/_services/projectResources/project-resources.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ProjectService } from 'src/app/_services/project/project.service';
@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit {
  projectResourcesForm
  // row data and column definitions  
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  tenantId: string;
  gridApi: any;
  gridColumnApi: any;
  form: FormGroup;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  currentUser: any;
  currentProjectId: any;
  selectedRow: any;
  parentProjectId: any;
  // userDropdownList = [];
  userDropdownList: Array<any> = [];
  getUserName: any;
  isPMOLeadORManager: boolean = false;
  isAdministrator: boolean = false;

  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private projectResourcesService: ProjectResourcesService,
    private allocationService: AllocationService,
    private projectService: ProjectService,
    private cdr: ChangeDetectorRef
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs(); 
   
    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };
    this.projectResourcesForm = new FormGroup({
      id :new FormControl(''),
      projectId :new FormControl(''),
      userId : new FormControl(''),
      userName : new FormControl(''),
      projectRole: new FormControl(''),
      projectAdminBoolean: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
      active: new FormControl('')
    })
  }

  ngOnInit(): void {
    this.getUserList();
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.currentUser.roles.includes('RoleAdministrator');
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.route.snapshot.queryParamMap.get('parentId');
    
    this.getProjectResourceByProjectId();
    this.getProjectById();
  }

  getProjectById(){
    this.projectService.getProjectById(this.currentProjectId).subscribe((response: any) =>{
      let lead = this.currentUser.id + " . " + this.currentUser.firstName + " " + this.currentUser.lastName;
      let creater = this.currentUser.firstName + " " + this.currentUser.lastName;
      let createrFullName = this.currentUser.firstName + " " + this.currentUser.middleName + " " + this.currentUser.lastName;
      if(response.projectManagerId === this.currentUser.id || response.projectController === lead || response.createdBy === creater || response.createdBy === createrFullName){
        this.isPMOLeadORManager = true;
      }
    });
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.userDropdownList = response.map((item: any) => `${item.id} . ${item.firstName} ${item.lastName}`);
      // console.log('Dropdown list:', this.userDropdownList);
      // for (let item of response) {
      //   this.userDropdownList.push(`${item.id} . ${item.firstName} ${item.lastName}`);
      // }
      // console.log(this.userDropdownList);
    });
    this.cdr.detectChanges();
  }

   //Get The Resource Project List
  getProjectResourceByProjectId(){
    this.projectResourcesService.getAllProjectResourcesByProjectId(this.currentProjectId).subscribe((response: any) => {
      this.rowData = response.result;
    });
  }

   // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
   onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }
  
    // create column definitions  
    private createColumnDefs() {
      return [
      {
        headerName: "Project Id",
        field: "projectId",
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: "User Name",
        field: "userName",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Project Role",
        field: "projectRole",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Start date",
        field: "startDate",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "End date",
        field: "endDate",
        filter: true,
        editable: false,
        sortable: true,
      },
      // {
      //   headerName: "Active",
      //   field: "active",
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      // }, 
    ]   
    }

    onSelectionChanged(event) {
      this.selectedCheckboxData = []
      let select = event.api.getSelectedNodes();
      for (let item of select) {
        this.selectedCheckboxData.push(item.data)
      }
    }

    isFirstColumn(params) {
      const displayedColumns = params.columnApi.getAllDisplayedColumns();
      const thisIsFirstColumn = displayedColumns[0] === params.column;
      return thisIsFirstColumn;
    }

    
    openProjectTab(param) {
      if(this.parentProjectId){
        this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId, parentId: this.parentProjectId } }); // pass current project id as parameter
      }
      else{
        this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
      }
    }
  
    backToMyProject() {
      if(this.parentProjectId){
        this.router.navigate([this.tenantId + '/dashboard/project/project-list/sub-project-list'], { queryParams: { projectID: this.parentProjectId} });
      }else{
        this.router.navigate([this.tenantId + '/dashboard/project/project-list/myproject']);
      }
    }

  createProjectResource() {
    let resourceData : String;
    resourceData = this.projectResourcesForm.get('userName').value.toString().replaceAll(",", " , ");

    let details = {
      projectId : this.currentProjectId,
      users: resourceData,
      // userId : this.projectResourcesForm.get('userName').value.split(' . ')[0],
      // userName : this.projectResourcesForm.get('userName').value.split(' . ')[1],
      projectRole: this.projectResourcesForm.get('projectRole').value,
      projectAdminBoolean: this.projectResourcesForm.get('projectAdminBoolean').value,
      startDate: this.projectResourcesForm.get('startDate').value,
      endDate: this.projectResourcesForm.get('endDate').value,
      active: true
      // active: this.projectResourcesForm.get('active').value,
    }
    this.projectResourcesService.createBulkProjectResources(details).subscribe((response: any) => {
      this.getProjectResourceByProjectId();
      $('#closeCreateModal').trigger("click");
    });
    // this.projectResourcesService.createprojectResources(details).subscribe((response: any) => {
    //    this.getProjectResourceByProjectId();
    //    $('#closeCreateModal').trigger("click");
    //  });
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.projectResourcesService.deleteProjectResources(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.getProjectResourceByProjectId();
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.projectResourcesForm.patchValue(this.selectedCheckboxData[0]);
    this.projectResourcesForm.value.userName = this.projectResourcesForm.value.userId + ' . ' + this.projectResourcesForm.value.userName;
    this.projectResourcesForm.patchValue(this.projectResourcesForm.value);
  }


  createOpenModal() {
    this.modeAction = 1;
    this.projectResourcesForm.reset();
  }

  updateProjectResource() {
    let details = {
      projectId : this.currentProjectId,
      userId : this.projectResourcesForm.get('userName').value.split(' . ')[0],
      userName : this.projectResourcesForm.get('userName').value.split(' . ')[1],
      projectRole: this.projectResourcesForm.get('projectRole').value,
      projectAdminBoolean: this.projectResourcesForm.get('projectAdminBoolean').value,
      startDate: this.projectResourcesForm.get('startDate').value,
      endDate: this.projectResourcesForm.get('endDate').value,
      active: true
      // active: this.projectResourcesForm.get('active').value,
    }
    this.projectResourcesService.updateProjectResources(details, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getProjectResourceByProjectId();
      this.selectedCheckboxData = []
      $('#closeCreateModal').trigger("click");
    })
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].capacityPlanningName}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].capacityPlanningName}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].capacityPlanningName}`;
    }
  }

  deleteProjectResource() {
    this.projectResourcesService.deleteProjectResources(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getProjectResourceByProjectId();
      this.selectedCheckboxData = []
      $('#closeModalDelete').trigger("click");
    });
  }

    // getter for easy access to form fields
    get f() {
      return this.projectResourcesForm.controls;
    }

      // to open edit modal
  openEdit(editCapacity, item) {
    this.selectedRow = item;
    this.projectResourcesForm.patchValue(item);
  }

}
